import { ExpandableToFullHeight } from "@faire/deprecated-retailer-visitor-shared/components/ExpandableToFullHeight/ExpandableToFullHeight";
import { Filter } from "@faire/deprecated-retailer-visitor-shared/components/Filters/Filter";
import { FilterName } from "@faire/deprecated-retailer-visitor-shared/components/Filters/FilterName";
import { useFilterStore } from "@faire/deprecated-retailer-visitor-shared/components/Filters/useFilterStore";
import { LeftCategoryNavigation } from "@faire/deprecated-retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/CategoryPageShareables/LeftNav/LeftCategoryNavigation";
import { useLoggedOutCategoryPageCurrentCategory } from "@faire/deprecated-retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/Context/useLoggedOutCategoryPageCurrentCategory";
import { useLoggedOutCategoryPageCatNavResponse } from "@faire/deprecated-retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/DataFetching/useLoggedOutCategoryPageCatNav/useLoggedOutCategoryPageCatNavResponse";
import { useViewport } from "@faire/web/common/hooks/useViewport";
import { Column } from "@faire/web/slate/Layout";
import { getSpacing, Spacer } from "@faire/web/slate/spacing";
import { responsiveMediaQueries } from "@faire/web/slate/Theme/responsiveMediaQueries";
import React from "react";
import styled from "styled-components";

export const LoggedOutCategoryPageFilterSidebar: React.FC<{
  className?: string;
}> = ({ className }) => {
  const categoryModel = useLoggedOutCategoryPageCurrentCategory();

  const totalPrimaryResultsCount =
    useLoggedOutCategoryPageCatNavResponse().data.totalPrimaryResultsCount;
  const {
    data: { isSideBarVisible },
  } = useFilterStore(["isSideBarVisible"]);
  const { isTabletAndBelow } = useViewport();

  if (isSideBarVisible || isTabletAndBelow) {
    return (
      <SidebarContainerWithFilters className={className}>
        <ExpandableToFullHeight>
          <LeftCategoryNavigation selectedCategory={categoryModel} />
        </ExpandableToFullHeight>
        <Spacer height="2x" />
        <Filter
          name={FilterName.LOGGED_OUT_CATEGORY}
          resultsCount={totalPrimaryResultsCount}
          headerSeparator
          isSticky
        />
      </SidebarContainerWithFilters>
    );
  }
  return null;
};

// eslint-disable-next-line @faire/prefer-slate-attrs -- use ResponsiveContentV2
const SidebarContainerWithFilters = styled(Column)`
  flex: 0 0 228px;
  margin-right: ${getSpacing("6x")};

  &&& {
    ${responsiveMediaQueries.tabletAndBelow} {
      display: none;
    }
  }
`;
